import React from 'react';
import '../styles/SetDisplay.css';

function SetDisplay({ sets = [], leader = null }) {
  if (!Array.isArray(sets) || sets.length === 0) return null;

  return (
    <div className="set-display">
      {sets.map((set, idx) => {
        const setWinner = set.teamA > set.teamB ? 'teamA' : set.teamB > set.teamA ? 'teamB' : null;
        
        return (
          <div key={idx} className="set-bubble">
            <div className="set-num">{idx + 1}</div>
            <div className="score">
              <div 
                className='score-num' 
                style={{ 
                  opacity: setWinner === 'teamB' ? 0.65 : 1,
                  fontWeight: 400 /* Keep thin like team names */
                }}
              >
                {set.teamA}
              </div>
              <div 
                className='score-num' 
                style={{ 
                  opacity: setWinner === 'teamA' ? 0.65 : 1,
                  fontWeight: 400 /* Keep thin like team names */
                }}
              >
                {set.teamB}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SetDisplay;
